import api from 'api';

export const loadReq1 = api('GET /api/errors-mocks/req1');
export const loadReq2 = api('GET /api/errors-mocks/req2');
export const loadReq3 = api('GET /api/errors-mocks/req3');
export const loadReq4 = api('GET /api/errors-mocks/req4');
export const loadReq5 = api('GET /api/errors-mocks/req5');
export const loadResetConnection = api(
  'GET /api/errors-mocks/reset-connection'
);
export const loadM500 = api('GET /api/errors-mocks/500');
// export const loadM400 = api('GET /api/errors-mocks/400');
export const loadInternalError = api('GET /api/errors-mocks/internal-error');
export const loadEconnreset = api('GET /api/errors-mocks/econnreset');

export const createEntity = api('GET /api/errors-mocks/createEntity');
export const updateEntity = api('GET /api/errors-mocks/updateEntity');
export const loadEntity = api('GET /api/errors-mocks/updateEntity/:id');
export const loadDetailsEntity = api(
  'GET /api/errors-mocks/updateEntity/:id/details'
);
export const updateCancelationStorm = api(
  'PUT /api/campaigns/:campaignId/cost-models/:id'
);

export const loadCancelationStorm = api(
  'GET /api/campaigns/:campaignId/cost-models/:id'
);
export const loadBigDataMultiselect = api('GET /api/big-data-multiselect');
export const loadInternalError500Long = api(
  'GET /api/errors-mocks/remote-internal-error-500-long'
);
